// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"1243":"01ce7644","2937":"eabe11fc"}[chunkId] || chunkId) + "." + {"336":"fb4613c22cb5aa8c","1167":"ce38dc0334eb9be9","1243":"01b5e6ff3605d306","2713":"ad02e915c7eacc4d","2937":"e4b34cba87c6b6bb","9510":"0a8a2258e5af1481"}[chunkId] + ".js";
};